import React, { FC, useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import { classNames } from '@dt/fe-utils'
import { menuMobx } from 'restaurant'
import CategoryItem from './CategoryItem'
import productStyleController from '@ctrls/productStyleController'
import { recommendMobx } from '@mobxStore'
import './index.scss'
import { useHistoryListen } from '@utils'

// interface
interface IProps {
  type: 'classic' | 'list';
}

const ProductList: FC<IProps> = ({ type }) => {
  const { categories } = recommendMobx
  /** 延迟计算栏加载图片 */
  const lazyTimer = useRef(null)

  // TODO 减少计算次数
  useEffect(() => {
    if (categories.length) {
      const products = recommendMobx.products.filter(item => menuMobx.isOpenSoldout ? item.saleCnt !== 0 : true)
      lazyTimer.current = setTimeout(() => {
        productStyleController.lazy(products)
      }, 50)
      productStyleController.scroll(0)
    }
  }, [categories])

  useHistoryListen((pathname) => {
    if (!['/recommend'].includes(pathname)) {
      if (lazyTimer.current) {
        clearTimeout(lazyTimer.current)
      }
      return
    }
  })

  return (
    <div
      className={classNames('product-list menu-product-wrapper', type)}
    >
      {
        categories.length ? (
          categories.map((category) => {
            return (
              <CategoryItem
                type={type}
                key={category.no}
                category={category}
              />
            )
          })
        ) : null
      }
    </div>
  )
}

export default observer(ProductList)
